import { ManageInviteLink } from './manage-invite-link'

interface Props {
  roomId: string
}

export function CreateInviteLink({ roomId }: Props) {
  return <ManageInviteLink roomId={roomId} isCreation />
}
